import { EnumAutoCreationDocumentTypes, EnumCustomerAddressTypes, EnumDeliveryMethods, EnumInvoicePaymentTypes, EnumPaymentRequestStatuses, EnumPaymentRequestSteps, EnumPaymentRequestTypes, EnumSystemTypes, EnumDocumentFilteringOption } from "@dato-proxy/enums";
import { EnumLanguages } from '@m4u-angular/core/framework/sysenums.enum';

export const Lists_EN =
{
    Properties:
    {
        Language: EnumLanguages.English
    },
    LedgerIsOpenStatuses:
        [
            {
                Text: 'Open',
                Value: true
            },
            {
                Text: 'Closed',
                Value: false
            }
        ],
    InvoicePaymentStatuses:
        [
            {
                Text: 'Not paid',
                Value: EnumInvoicePaymentTypes.NotPaid
            },
            {
                Text: 'Paid partially',
                Value: EnumInvoicePaymentTypes.PaidPartially
            },
            {
                Text: 'Paid',
                Value: EnumInvoicePaymentTypes.Paid
            },
            {
                Text: 'Outstanding credit',
                Value: EnumInvoicePaymentTypes.OutstandingCredit
            },
            {
                Text: 'Open',
                Value: EnumInvoicePaymentTypes.Open
            },
            {
                Text: 'Closed',
                Value: EnumInvoicePaymentTypes.Closed
            }
        ],
    ChoiseCardByPayment:
        [
            {
                Text: 'Use existing credit card ending with {0}',
                Value: 'Old',
                SortOrder: 0
            },
            {
                Text: 'Enter a new credit card',
                Value: 'New',
                SortOrder: 1
            }
        ],
    ReportTabs:
        [
            {
                index: 0,
                text: 'Ledger',
                Type: 0
            },
            {
                index: 1,
                text: 'Documents report',
                Type: 1
            },
            {
                index: 2,
                text: 'Aging report',
                Type: 2
            },
            {
                index: 3,
                text: 'Deliveries report',
                Type: 3
            },
        ],
    ReportTabsLandLord:
        [
            {
                index: 0,
                text: 'Ledger',
                Type: 0
            },
            {
                index: 1,
                text: 'Documents report',
                Type: 1
            },
            {
                index: 2,
                text: 'Aging report',
                Type: 2
            },
            {
                index: 3,
                text: 'Proformas report',
                Type: 3
            },
        ],
    ReportTabsZulu:
        [
            {
                index: 0,
                text: 'Ledger',
                Type: 0
            },
            {
                index: 1,
                text: 'Documents report',
                Type: 1
            },
            {
                index: 2,
                text: 'Aging report',
                Type: 2
            },
            {
                index: 3,
                text: 'Deliveries report',
                Type: 3
            },
        ],
    CustomerAddressTabs:
        [
            {
                index: 1,
                text: 'Bill-to Addresses',
                Value: EnumCustomerAddressTypes.Bill,
                Name: 'BillCustomerAddresses'
            },
            {
                index: 0,
                text: 'Ship-to Addresses',
                Value: EnumCustomerAddressTypes.Ship,
                Name: 'ShipCustomerAddresses'
            }
        ],
    AutoCreationDocumentType: [
        {
            SortOrder: 1,
            Text: 'Invoice',
            Value: EnumAutoCreationDocumentTypes.Invoice
        }, {
            SortOrder: 2,
            Text: 'Order',
            Value: EnumAutoCreationDocumentTypes.Order
        }, {
            SortOrder: 3,
            Text: 'None',
            Value: EnumAutoCreationDocumentTypes.None
        }
    ],
    PaymentRequestStatuses: [
        {
            SortOrder: 1,
            Text: 'Payment request',
            Value: EnumPaymentRequestStatuses.Sent
        }, {
            SortOrder: 2,
            Text: 'Credit card updated',
            Value: EnumPaymentRequestStatuses.Confirmed
        }, {
            SortOrder: 3,
            Text: 'Executed',
            Value: EnumPaymentRequestStatuses.Executed
        }, {
            SortOrder: 4,
            Text: 'Error when paying',
            Value: EnumPaymentRequestStatuses.Error
        }, {
            SortOrder: 5,
            Text: 'Handling required',
            Value: EnumPaymentRequestStatuses.Cancelled
        }, {
            SortOrder: 6,
            Text: 'Resolved manualy',
            Value: EnumPaymentRequestStatuses.Resolved
        }
    ],
    PaymentRequestTypes: [
        {
            SortOrder: 1,
            Text: 'Existing card',
            Value: EnumPaymentRequestTypes.PaymentByExistingCard
        }, {
            SortOrder: 2,
            Text: 'New card',
            Value: EnumPaymentRequestTypes.PaymentByNewCard
        }, {
            SortOrder: 3,
            Text: 'Paypal',
            Value: EnumPaymentRequestTypes.Paypal
        }, {
            SortOrder: 4,
            Text: 'Bit',
            Value: EnumPaymentRequestTypes.Bit
        }
    ],
    PaymentRequestSteps: [
        {
            SortOrder: 1,
            Text: 'Send',
            Value: EnumPaymentRequestSteps.SendToPaymentService
        }, {
            SortOrder: 2,
            Text: 'Confirm',
            Value: EnumPaymentRequestSteps.ConfirmInPaymentService
        }, {
            SortOrder: 3,
            Text: 'Execute',
            Value: EnumPaymentRequestSteps.ExecuteInPaymentService
        }, {
            SortOrder: 4,
            Text: 'Save Invoice',
            Value: EnumPaymentRequestSteps.SaveInvoice
        }, {
            SortOrder: 5,
            Text: 'Save Order',
            Value: EnumPaymentRequestSteps.SaveOrder
        }, {
            SortOrder: 6,
            Text: 'Save Receipt',
            Value: EnumPaymentRequestSteps.SaveReceipt
        }, {
            SortOrder: 7,
            Text: 'Update Transaction Ref Data',
            Value: EnumPaymentRequestSteps.UpdateTransactionRefDataInPaymentService
        }, {
            SortOrder: 8,
            Text: 'Save Credit Card',
            Value: EnumPaymentRequestSteps.SaveCreditCard
        }, {
            SortOrder: 9,
            Text: 'Send Invoice',
            Value: EnumPaymentRequestSteps.SendInvoice
        }, {
            SortOrder: 10,
            Text: 'Send Order',
            Value: EnumPaymentRequestSteps.SendOrder
        }, {
            SortOrder: 11,
            Text: 'Send Receipt',
            Value: EnumPaymentRequestSteps.SendReceipt
        }, {
            SortOrder: 12,
            Text: 'Rollback',
            Value: EnumPaymentRequestSteps.Rollback
        }, {
            SortOrder: 13,
            Text: 'Admin notification sent',
            Value: EnumPaymentRequestSteps.AdminNotificationSent
        }, {
            SortOrder: 14,
            Text: 'Transfered to payment service',
            Value: EnumPaymentRequestSteps.TransferedToPaymentService
        }
    ],
    SystemTypes: [
        {
            SortOrder: 1,
            Text: 'SBO',
            Value: EnumSystemTypes.SBO
        }, {
            SortOrder: 2,
            Text: 'Landlord',
            Value: EnumSystemTypes.Landlord
        }, {
            SortOrder: 3,
            Text: 'Zulu',
            Value: EnumSystemTypes.Zulu
        }
    ],
    MyDetailsTabs: [
        {
            index: 0,
            text: 'Contact persons',
            Name: 'ContactPersons'
        },
        {
            index: 1,
            text: 'Customer addresses',
            Name: 'CustomerAddresses'
        }
    ],
    DeliveryMethods: [
        {
            SortOrder: 1,
            Text: 'Email',
            Value: EnumDeliveryMethods.Email
        },
        {
            SortOrder: 2,
            Text: 'Phone',
            Value: EnumDeliveryMethods.Phone
        },
        {
            SortOrder: 3,
            Text: 'WhatsApp',
            Value: EnumDeliveryMethods.WhatsApp
        }
    ],
    DocumentFilteringOption: [
        {
            SortOrder: 1,
            Text: 'Show Open',
            Value: EnumDocumentFilteringOption.ShowOpen
        }, {
            SortOrder: 2,
            Text: 'Show All',
            Value: EnumDocumentFilteringOption.ShowAll
        }, {
            SortOrder: 3,
            Text: 'Automatic',
            Value: EnumDocumentFilteringOption.Automatic
        }
    ]
};
